<template>
    <div class="content content__home">
        <blocks
            :blocks="blocks">
        </blocks>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import Blocks from '@/components/Blocks';

    export default {
        name: 'Home',
        components: {
            Blocks
        },
        computed: mapState([
            'ready',
            'pages',
            'slug',
            'favorites'
        ]),
        data: function () {
            return {
                title: null,
                color: null,
                blocks: [],
            }
        },

        created() {
            this.getPage();
        },
        methods: {
            ...mapActions([
                'loadPage',
                'setColor']),
            async getPage() {
                try {
                    const slug = "frontpage";
                    await this.loadPage(slug);

                    if(typeof this.pages['frontpage'] != 'undefined') {

                        const page = this.pages[slug];

                        let blocks = [];
                        blocks = blocks.concat(page.blocks);

                        if(!this.favorites.length) {
                            if(page.blocksNoFavorites && page.blocksNoFavorites.length) {
                                blocks = blocks.concat(page.blocksNoFavorites);
                            }
                        } else {
                            if(page.blocksFavorites && page.blocksFavorites.length) {
                                const pageLinks = [];
                                for(const favorite of this.favorites) {
                                    pageLinks.push({
                                        __typename: 'blocks_link_BlockType',
                                        heading: favorite.title,
                                        page: [{
                                                slug: favorite.slug,
                                                parent: {
                                                    slug: favorite.parentSlug
                                                },
                                            }]});
                                }
                                blocks = blocks.concat(page.blocksFavorites, pageLinks);
                            }
                        }

                        this.title = page.title;
                        this.color = page.color;
                        this.blocks = blocks;
                        this.setColor(page.color);
                    }
                } catch (e) {
                    window.console.log(e);
                }
            }
        }        
    };
</script>

<style lang="scss">
    .content {

        &__home {

            .content__block__image {
                display: block;
                margin:0 auto 50px auto;
                max-width: 320px;
                max-height: 320px;
            }
        }
        
    }
</style>